import { axiosInstance } from '@configs/axios/axiosInstance';

import type { CreateUserNotificationPreferenceRequest } from './createUserNotificationPreferenceRequest.types';

export async function createUserNotificationPreference(
  payload: CreateUserNotificationPreferenceRequest
): Promise<void> {
  await axiosInstance.post(
    '/client-profiles/notification-preference',
    payload
  );
}
